import React, { useEffect, useState } from 'react';
import AuthManager from '../utils/AuthManager';

const CUNGVEDICH_API_BASE_URL =
  process.env.REACT_APP_CUNGVEDICH_API_URL || 'https://api.cungvedich.vn/api';

export default function AutoLoginPage() {
  const [error, setError] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    // redirect nội bộ sau đăng nhập (vd /f1). Chặn open-redirect: chỉ chấp nhận path bắt đầu bằng đúng 1 dấu "/".
    const redirectParam = params.get('redirect') || '/';
    const redirect = redirectParam.startsWith('/') && !redirectParam.startsWith('//') ? redirectParam : '/';
    // imp=1 → "xem dưới tài khoản F1" TẠM THỜI (sessionStorage), không đụng phiên gốc localStorage.
    const isImpersonate = params.get('imp') === '1';
    if (!token) {
      setError('Thiếu token. Vui lòng yêu cầu link mới từ Admin.');
      return;
    }

    fetch(`${CUNGVEDICH_API_BASE_URL}/auth/login-with-token`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    })
      .then((res) => res.json())
      .then((json) => {
        // TransformInterceptor wraps: { statusCode, data: { accessToken, userInfo } }
        const d = json?.data;
        if (!d?.accessToken || !d?.userInfo) {
          throw new Error('Token không hợp lệ hoặc đã hết hạn.');
        }
        if (isImpersonate) {
          AuthManager.saveImpersonation(d.userInfo, d.accessToken);
        } else {
          AuthManager.saveSession(d.userInfo, d.accessToken);
        }
        window.location.replace(redirect);
      })
      .catch((err) => setError(err.message || 'Đăng nhập thất bại.'));
  }, []);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="bg-white rounded-xl shadow p-8 max-w-sm w-full text-center">
          <div className="text-4xl mb-4">⚠️</div>
          <p className="text-gray-700 font-medium mb-2">Không thể đăng nhập</p>
          <p className="text-sm text-gray-500">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-brand-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-gray-500 text-sm">Đang đăng nhập...</p>
      </div>
    </div>
  );
}
